const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

const weekdayNames = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

export const RECURRENCE_TYPE_FIXED = 'fixed';
export const RECURRENCE_TYPE_FLOATING = 'floating';

export const recurrenceTypeOptions = Object.freeze([
  {id: RECURRENCE_TYPE_FIXED, label: 'Fixed Date'},
  {id: RECURRENCE_TYPE_FLOATING, label: 'Floating Holiday'},
]);

export const recurrenceMonthOptions = Object.freeze(
  monthNames.map((label, index) => ({
    id: index + 1,
    label,
  })),
);

export const recurrenceWeekOptions = Object.freeze([
  {id: 1, label: 'First'},
  {id: 2, label: 'Second'},
  {id: 3, label: 'Third'},
  {id: 4, label: 'Fourth'},
  {id: -1, label: 'Last'},
]);

export const recurrenceWeekdayOptions = Object.freeze(
  weekdayNames.map((label, index) => ({
    id: index + 1,
    label,
  })),
);

const pad = (value) => String(value).padStart(2, '0');

const getTargetWeekday = (weekday) => (weekday === 7 ? 0 : weekday);

export const findOptionById = (options, id) =>
  options.find((option) => option.id === id) ?? null;

export const computeFloatingDate = (year, month, week, weekday) => {
  if (!year || !month || !week || !weekday) {
    return '';
  }

  const targetWeekday = getTargetWeekday(weekday);
  let result;

  if (week === -1) {
    const lastOfMonth = new Date(year, month, 0);
    const offset = (lastOfMonth.getDay() - targetWeekday + 7) % 7;
    result = new Date(year, month - 1, lastOfMonth.getDate() - offset);
  } else {
    const firstOfMonth = new Date(year, month - 1, 1);
    const offset = (targetWeekday - firstOfMonth.getDay() + 7) % 7;
    result = new Date(year, month - 1, 1 + offset + (week - 1) * 7);

    if (result.getMonth() !== month - 1) {
      return '';
    }
  }

  return `${result.getFullYear()}-${pad(result.getMonth() + 1)}-${pad(
    result.getDate(),
  )}`;
};

export const syncFloatingHolidayDate = (holiday) => {
  if (
    !holiday.recurring ||
    holiday.recurrenceType?.id !== RECURRENCE_TYPE_FLOATING ||
    !holiday.date ||
    !holiday.recurrenceMonth ||
    !holiday.recurrenceWeek ||
    !holiday.recurrenceWeekday
  ) {
    return holiday.date;
  }

  const year = Number(String(holiday.date).slice(0, 4));

  if (!year) {
    return holiday.date;
  }

  return (
    computeFloatingDate(
      year,
      holiday.recurrenceMonth.id,
      holiday.recurrenceWeek.id,
      holiday.recurrenceWeekday.id,
    ) || holiday.date
  );
};

export const buildHolidayPayload = (holiday) => {
  const recurrenceType = holiday.recurring
    ? holiday.recurrenceType?.id ?? RECURRENCE_TYPE_FIXED
    : null;
  const isFloating = recurrenceType === RECURRENCE_TYPE_FLOATING;

  return {
    name: holiday.name,
    date: holiday.date,
    recurring: holiday.recurring,
    length: holiday.length.id,
    recurrenceType,
    recurrenceMonth: isFloating ? holiday.recurrenceMonth?.id ?? null : null,
    recurrenceWeek: isFloating ? holiday.recurrenceWeek?.id ?? null : null,
    recurrenceWeekday: isFloating
      ? holiday.recurrenceWeekday?.id ?? null
      : null,
  };
};
